/* eslint-disable import/prefer-default-export */
import api from "./axios";

export async function getAbsences(absence_user_id) {
  const response = await api.get(`/absences/${absence_user_id}`);
  return response;
}

export async function postAbsence(absence) {
  const response = await api.post("/absences", absence);
  return response;
}

export async function deleteAbsence(absenceId) {
  const response = await api.delete(`/absences/${absenceId}`);
  return response;
}

export async function putAbsence(absence, absenceId) {
  const response = await api.put(`/absences/${absenceId}`, absence);
  return response;
}
